import { BlankLayout } from '@/components/layouts';

export default [
  {
    path: '/designer',
    name: 'Designer',
    component: BlankLayout,
    meta: { module: '主页' },
    children: [
      {
        path: '/designer/home-page/:id',
        name: 'Designer.HomePage',
        component: () => import(/* webpackChunkName: 'designer-home-page' */ '../../views/homepage/HomePage.vue'),
        meta: { title: '个人主页' },
      },
    ],
  },
];
